/**
 * INFINITY LIFE 2.0 — Interactive PWA Installation Modal
 */

import { store } from '../state.js';
import { promptPWAInstall } from '../pwa.js';

export function renderInstallPrompt() {
  const { modals } = store.get();

  if (!modals.installPrompt) {
    return `<div id="install-modal-container"></div>`;
  }

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  return `
    <div class="modal-overlay open" id="install-modal-overlay">
      <div class="modal-card" style="max-width: 460px; text-align: center;">
        <div class="modal-header" style="justify-content: flex-end; border: none; padding-bottom: 0;">
          <button class="btn-close" id="btn-close-install-modal">✕</button>
        </div>

        <img src="/icons/icon-192.svg" alt="Infinity Life" style="width: 72px; height: 72px; margin: 0 auto 16px auto;" />
        <h2 style="font-size: 1.35rem; font-weight: 800; margin-bottom: 8px;">Instalar o Infinity Life</h2>
        <p style="font-size: 0.9rem; color: var(--text-secondary); line-height: 1.5; margin-bottom: 24px;">
          Instale como aplicativo nativo no seu celular ou computador para acesso instantâneo, funcionamento offline e notificações reais.
        </p>

        ${isIOS ? `
          <!-- iOS Safari Specific Instructions -->
          <div style="background: var(--bg-tertiary); border: 1px solid var(--border-subtle); border-radius: var(--radius-md); padding: 18px; text-align: left; margin-bottom: 20px;">
            <div style="font-weight: 700; color: var(--text-primary); margin-bottom: 12px; display: flex; align-items: center; gap: 8px;">
              <span>🍎</span> <span>Como instalar no iPhone / iPad:</span>
            </div>
            <ol style="padding-left: 20px; font-size: 0.85rem; color: var(--text-secondary); line-height: 1.8;">
              <li>No navegador Safari, toque no botão <strong>Compartilhar</strong> (ícone com quadrado e seta para cima).</li>
              <li>Role as opções para baixo e selecione <strong>Adicionar à Tela de Início</strong>.</li>
              <li>No canto superior direito, toque em <strong>Adicionar</strong>.</li>
            </ol>
          </div>
        ` : `
          <!-- Android / Chrome / Edge Instructions -->
          <button class="btn-primary" id="btn-trigger-pwa-install" style="width: 100%; justify-content: center; padding: 12px; font-size: 1rem; margin-bottom: 12px;">
            <span>📲</span> <span>Adicionar à Tela Inicial / Computador</span>
          </button>
        `}

        <button class="btn-secondary" id="btn-dismiss-install" style="width: 100%; justify-content: center;">
          Agora Não
        </button>
      </div>
    </div>
  `;
}

export function attachInstallPromptEvents(container) {
  const closeBtn = container.querySelector('#btn-close-install-modal');
  const dismissBtn = container.querySelector('#btn-dismiss-install');
  const overlay = container.querySelector('#install-modal-overlay');

  const close = () => store.toggleModal('installPrompt', false);

  if (closeBtn) closeBtn.addEventListener('click', close);
  if (dismissBtn) dismissBtn.addEventListener('click', close);
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });
  }

  const triggerBtn = container.querySelector('#btn-trigger-pwa-install');
  if (triggerBtn) {
    triggerBtn.addEventListener('click', () => {
      promptPWAInstall();
      close();
    });
  }
}
